export default __webpack_public_path__ + "static/media/slider2-img-1.c33e1a32.svg";